import React from 'react'
import './about.css'
import Seperator from '../../Common/Seperator/Seperator'

const About = () => {
  return (
    <div className='about'>
      <div data-aos="fade-up" className="c-title"> <Seperator/> <h2>About me</h2> <Seperator/></div>
      <div className="content-about">
      <div data-aos="fade-right" className="content-a">
        <h2>Profesionally</h2>
        <p>What's up, Dear Reader. I'm Dhruv Asth, A Web and Game Developer and UI/UX/Graphic Designer. I'm looking for a role in
            established IT company with the opportunity to work with the latest technologies on challenging and diverse projects.
            I'm quietly confident, naturally curious, and perpetually working on improving my chops one design problem at a time. 
            My love of travel and breadth of experience informs and directs in my work.</p>
            <a href='#projects' className='button-aa' >Recent Work</a>
      </div>
      <div data-aos="fade-up" className="a-img">
        <div>Think.</div>
        <div>Create.</div>
        <div>Code.</div>
      </div>
      <div data-aos="fade-left" className="content-b">
      <h2>Personally</h2>
        <p>I love music, games, home improvement projects, gym and tech obsessed. I love exploring new technologies and
        reading books but often I try to reasearch about wildlife and try to make sure that somehow i can make a better world for 
        these animals too. I'm a family man and I try to help people as much as i can. If I need to define myself in one
        sentence that would be a hardworking boy trying to achieve his dream goals.</p>
        <a href='https://medium.com/me/stories/drafts' className='button-ab' >Blog</a>
      </div>
      </div>
    </div>
  )
}

export default About